/**
  * ReviewLoading.jsx
  * Created by Kevin Li 6/21/16
  */

const ReviewLoading = () => {
    return (
        <div className="container">
            <h4 className="usa-da-review-data usa-da-gathering-data">Gathering data...</h4>
        </div>
    );
};

export default ReviewLoading;
